import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { isNativeApp } from "@/lib/platform";
import CruiserContactsView from "@/components/CruiserContactsView";

/**
 * Cruiser Contacts standalone page (web-only).
 *
 * As of Feb 8, 2026 the actual list/grid/modal wiring lives in
 * `@/components/CruiserContactsView` so the new Dashboard "Contacts" tab
 * can share exactly the same UI. This page is now just page chrome
 * (header + back-to-helm) around that shared view.
 *
 * Native (iOS/Android) users still get redirected back to /app because
 * contacts are more discoverable via the in-app "Contacts" tab now.
 */
export default function CruiserContacts() {
    const nav = useNavigate();

    useEffect(() => {
        if (isNativeApp()) {
            nav("/app", { replace: true });
        }
    }, [nav]);

    return (
        <div data-testid="cruiser-contacts-page" style={{ minHeight: "100vh", background: "var(--bm-bg-0)", padding: "20px 16px 80px" }}>
            <div style={{ maxWidth: 1100, margin: "0 auto" }}>
                <div style={{
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                    gap: 12, flexWrap: "wrap", marginBottom: 8,
                }}>
                    <button
                        data-testid="cruiser-contacts-back-btn"
                        onClick={() => nav("/app")}
                        className="bm-btn bm-btn-ghost"
                        style={{ fontSize: 13 }}
                        type="button"
                    >
                        <ArrowLeft size={14} /> Back to helm
                    </button>
                </div>

                <CruiserContactsView
                    heading="People you've met on the water"
                    subheading="Because you recognize boats better than people. Log the hull, remember the crew, find them next season."
                />
            </div>
        </div>
    );
}
